import ApiService from '../common/services/api.service';

export default {
  data() {
    return {
      debugLog: process.env.VUE_APP_ENV !== 'production',
      showWarnings: true,
      perPage: 100,
      currentPage: 1,
      finishedLoading: false,
      defaultLocale: 'en-US',
      currentLanguage: 'en-US',
    };
  },
  mounted() {
  },
  methods: {
    /**
     * All reused components need to have a start state that is known good, so reset is common
     */
    reset() {
    },
    /**
     * This method should always be called on when loading in data
     */
    initialLoad() {
    },
    /**
     * this just calls reset then initial load, pretty simple
     */
    reload() {
      this.reset();
      this.initialLoad();
    },
    /**
     * Generic open modal method
     */
    openModal(modalId) {
      if (modalId) {
        this.$bvModal.show(modalId);
      }
    },
    /**
     * inverse of openModal, generic closing of modals.
     * @param modalId
     */
    closeModal(modalId) {
      if (modalId) {
        this.$bvModal.hide(modalId);
      }
    },
    /**
     * This sends an error growl for default of 10 seconds
     * @param title
     * @param text
     * @param duration
     */
    errorGrowl(title = null, text = null, duration = 10000) {
      this.growl(title, text, 'error', duration);
    },
    /**
     * This sends an warn growl for default of 10 seconds
     * @param title
     * @param text
     * @param duration
     */
    warnGrowl(title = null, text = null, duration = 10000) {
      this.growl(title, text, 'warn', duration);
    },
    /**
     * This sends an success growl for default of 10 seconds
     * @param title
     * @param text
     * @param duration
     */
    successGrowl(title = null, text = null, duration = 10000) {
      this.growl(title, text, 'success', duration);
    },
    infoGrowl(title = null, text = null, duration = 10000) {
      this.growl(title, text, null, duration);
    },
    /**
     * This is just a mapping of simple growl commands to the library
     * @param title
     * @param text
     * @param type
     * @param duration
     * @param width
     */
    growl(title = null, text = null, type = null, duration = 10000, width = 350) {
      this.$notify({
        // eslint-disable-next-line
        title: title,
        // eslint-disable-next-line
        text: text,
        // eslint-disable-next-line
        type: type,
        // eslint-disable-next-line
        width: width,
        // eslint-disable-next-line
        duration: duration,
      });
    },
    /**
     * Downloading a file from a link is a bit weird so we wrote this to get around it
     * @param url
     * @param filename
     * @param mimeType
     * @returns {Promise<unknown>}
     */
    downloadFile(url, filename, mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return ApiService.downloadFile(url)
        .then((response) => {
          const newBlob = new Blob([response.data], { type: mimeType });
          newBlob.name = filename;
          newBlob.lastModifiedDate = new Date();
          //
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob, filename);
            return;
          }
          //
          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const fileURL = window.URL.createObjectURL(newBlob);
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(fileURL);
          }, 100);
        });
    },
  },
};
